module.exports = __webpack_public_path__ + "img/d99af1ff-25d4-4d05-80b0-fbd22977d082.1e935d76.png";